export const RQReveiwKey = {
  mainReviewProducts: ['main', 'review'] as const,
  productReviews: (productId: number) => ['productReviews', productId] as const,
  myReviews: ['reviews', 'me'] as const,
  myReviewDetail: (id: number) => ['review', id] as const,
  itemContainer: (id: number) => ['container', id] as const,
};
